import React from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import styles from './PageLoading.module.scss';

/**
 * 页面加载中的 Suspense fallback 组件
 * 用于路由懒加载时的加载状态显示
 */
export const PageLoading: React.FC = () => {
  return (
    <div className={styles.container}>
      <LoadingSpinner className={styles.spinner} size={64} />
    </div>
  );
};

export default PageLoading;
